
















import {Vue,Component, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import FullDialog from '@/components/UI/FullDialog.vue';

const appStore = namespace('app')

@Component({
  components: {FullDialog}
})
export default class LfsLayout extends Vue {

  @appStore.Mutation('setScrollHeight') protected setScrollHeight: any
  @appStore.Getter('GetScrollHeight') protected GetScrollHeight:any

  @Ref('box') readonly box!:HTMLElement

  onScroll () {
    // const param:number = this.box.getBoundingClientRect().y
    // this.setScrollHeight(param)
  }

  protected mounted() {
    // window.addEventListener ('scroll', this.onScroll);
    // this.$store.dispatch('testing/load');
  }
}

